import { Directive, HostListener, HostBinding, inject, input, computed } from '@angular/core';
import { CommunityMobileEventsService } from '../services/util/mobile-events.service';

@Directive({
  selector: 'a[olExternalLink]',
})
export class ExternalLinkDirective {
  olExternalLink = input.required<string>();
  isMajiApp = input<boolean>(false);

  private mobileEventsService = inject(CommunityMobileEventsService);

  private shouldUseWebView = computed(() => this.isMajiApp() && this.mobileEventsService.isWebView);

  @HostBinding('attr.href')
  get href(): string | null {
    return this.shouldUseWebView() ? null : this.olExternalLink();
  }

  @HostBinding('attr.target')
  get target(): string | null {
    return this.shouldUseWebView() ? null : '_blank';
  }

  @HostBinding('attr.rel')
  get rel(): string | null {
    return this.shouldUseWebView() ? null : 'noopener noreferrer';
  }

  @HostListener('click', ['$event'])
  onClick(event: Event): void {
    if (this.shouldUseWebView()) {
      event.preventDefault();
      this.mobileEventsService.openUrl(this.olExternalLink());
    }
  }
}
